export default {"src":"/_next/static/media/taro.6bf66a47.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};